import Link from 'next/link';
import { useRouter } from 'next/router';
import { cn } from '@/utils';

import SvgArrowLeft from '../Icons/ArrowLeft';

type Prop = {
  route?: string;
  useGoBack?: boolean;
  className?: string;
  hideLabel?: boolean;
};

const ButtonBack = ({ route = '#', useGoBack = false, hideLabel = false, className }: Prop) => {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (useGoBack) {
      e.preventDefault();
      router.back();
    }
  };

  return (
    <Link
      href={route}
      className={cn('group flex w-fit cursor-pointer flex-row items-center gap-3 ps-4', className)}
      onClick={handleClick}
    >
      <SvgArrowLeft className="text-primary" />
      {!hideLabel && (
        <label className="cursor-pointer font-workSans leading-[24px] text-primary group-hover:text-primaryDark">
          {'Regresar'}
        </label>
      )}
    </Link>
  );
};

export default ButtonBack;
